/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inserting_Blank_Frames_SuccessInputs */

const en_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserting blank frames finished successfully`)
};

const fr_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion d’images vides terminée avec succès`)
};

const de_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Einfügen der leeren Rahmen wurde erfolgreich abgeschlossen.`)
};

const it_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento di cornici vuote completato con successo`)
};

const ru_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка пустых рамок успешно завершена.`)
};

const es_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La inserción de marcos en blanco finalizó correctamente`)
};

const zh_cn2_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白框插入完成`)
};

const ja_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白フレームの挿入が正常に完了しました`)
};

const hi_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डालने की प्रक्रिया सफलतापूर्वक पूरी हो गई।`)
};

const pt_pt2_inserting_blank_frames_success = /** @type {(inputs: Inserting_Blank_Frames_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A inserção das molduras em branco foi concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Inserting blank frames finished successfully" |
*
* @param {Inserting_Blank_Frames_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const inserting_blank_frames_success = /** @type {((inputs?: Inserting_Blank_Frames_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inserting_Blank_Frames_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_inserting_blank_frames_success(inputs)
	if (locale === "de") return de_inserting_blank_frames_success(inputs)
	if (locale === "it") return it_inserting_blank_frames_success(inputs)
	if (locale === "ru") return ru_inserting_blank_frames_success(inputs)
	if (locale === "es") return es_inserting_blank_frames_success(inputs)
	if (locale === "zh-CN") return zh_cn2_inserting_blank_frames_success(inputs)
	if (locale === "ja") return ja_inserting_blank_frames_success(inputs)
	if (locale === "hi") return hi_inserting_blank_frames_success(inputs)
	if (locale === "pt-PT") return pt_pt2_inserting_blank_frames_success(inputs)
	return en_inserting_blank_frames_success(inputs)
});